// extracted by mini-css-extract-plugin
export default {"success":"WDYZNsYJ","mobile":"mobile","text":"p056phpL","link":"w5NL0jEt"};